<div class="app-wrapper">
  <div class="container">
    <div
      class="image-container animate__animated animate__pulse animate__infinite"
    ></div>
    <zodi-header></zodi-header>
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
    <zodi-messages></zodi-messages>
  </div>
  <zodi-footer></zodi-footer>
</div>
<zodi-loading-overlay *ngIf="loading"></zodi-loading-overlay>
